import {Component, Injector} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {StoreSelectorsService} from "../../../../services";
import {TouchLib} from "../../touch/touchLib";

@Component({
    selector: 'app-scene-block-button',
    templateUrl: './block-button.component.html',
    styleUrls: ['./block-button.component.scss']
})
export class BlockButtonComponent extends BlockBaseComponent {

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        private injector: Injector
    ) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }


    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.label', {}, this.translocoService.getActiveLang()),
                inputType: "text",
                name: "label",
                storePath: 'Data[0].Button[0].$.label'
            },
            {
                type: "input",
                value: '',
                label: this.translocoService.translate('general.fieldName', {}, this.translocoService.getActiveLang()),
                name: "fieldName",
                inputType: "text",
                storePath: 'Data[0].Button[0].$.fieldName'
            }
        ];
    }

    /**
     * Touch action handler - delegates to TouchLib
     */
    public override onTouchAction() {
        if (!this.sceneId || !this.dialog || !this.injector) return;
        TouchLib.handleTouchAction(this.sceneId, this.dialog, this.injector);
    }
}

